"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var js_sha256_1 = require("js-sha256");
var DynamicConfig_1 = __importDefault(require("./DynamicConfig"));
var Base64_1 = require("./utils/Base64");
var StatsigAsyncStorage_1 = __importDefault(require("./utils/StatsigAsyncStorage"));
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
function getHashValue(value) {
    var buffer = js_sha256_1.sha256.create().update(value).arrayBuffer();
    return Base64_1.Base64.encodeArrayBuffer(buffer);
}
var OVERRIDES_STORE_KEY = 'STATSIG_LOCAL_STORAGE_INTERNAL_STORE_OVERRIDES_V3';
var STICKY_DEVICE_EXPERIMENTS_KEY = 'STATSIG_LOCAL_STORAGE_STICKY_DEVICE_EXPERIMENTS';
// V4 change: values are now cached on a specific user ID. We store values for up to 10 different user IDs at a time.
var INTERNAL_STORE_KEY = 'STATSIG_LOCAL_STORAGE_INTERNAL_STORE_V4';
var MAX_USER_VALUE_CACHED = 10;
var StatsigStore = /** @class */ (function () {
    function StatsigStore(sdkInternal) {
        this.overrides = {
            gates: {},
            configs: {},
        };
        this.sdkInternal = sdkInternal;
        this.values = {};
        this.values[this.getCurrentUserCacheKey()] = {
            feature_gates: {},
            dynamic_configs: {},
            sticky_experiments: {},
            time: 0,
        };
        this.stickyDeviceExperiments = {};
        this.loaded = false;
        this.loadFromLocalStorage();
    }
    StatsigStore.prototype.loadFromAsyncStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.parseCachedValues;
                        return [4 /*yield*/, StatsigAsyncStorage_1.default.getItemAsync(INTERNAL_STORE_KEY)];
                    case 1:
                        _b = [_c.sent()];
                        return [4 /*yield*/, StatsigAsyncStorage_1.default.getItemAsync(STICKY_DEVICE_EXPERIMENTS_KEY)];
                    case 2:
                        _a.apply(this, _b.concat([_c.sent()]));
                        this.loaded = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    StatsigStore.prototype.loadFromLocalStorage = function () {
        if (StatsigAsyncStorage_1.default.asyncStorage) {
            return;
        }
        this.parseCachedValues(StatsigLocalStorage_1.default.getItem(INTERNAL_STORE_KEY), StatsigLocalStorage_1.default.getItem(STICKY_DEVICE_EXPERIMENTS_KEY));
        this.loaded = true;
    };
    StatsigStore.prototype.isLoaded = function () {
        return this.loaded;
    };
    StatsigStore.prototype.parseCachedValues = function (allValues, deviceExperiments) {
        try {
            this.values = allValues ? JSON.parse(allValues) : this.values;
        }
        catch (e) {
            // Cached value corrupted, remove cache
            this.removeFromStorage(INTERNAL_STORE_KEY);
        }
        try {
            var deviceExpParsed = deviceExperiments
                ? JSON.parse(deviceExperiments)
                : null;
            if (deviceExpParsed) {
                this.stickyDeviceExperiments = deviceExpParsed;
            }
        }
        catch (e) {
            this.removeFromStorage(STICKY_DEVICE_EXPERIMENTS_KEY);
        }
        this.loadOverrides();
    };
    StatsigStore.prototype.removeFromStorage = function (key) {
        StatsigAsyncStorage_1.default.removeItemAsync(key);
        StatsigLocalStorage_1.default.removeItem(key);
    };
    StatsigStore.prototype.loadOverrides = function () {
        var overrides = StatsigLocalStorage_1.default.getItem(OVERRIDES_STORE_KEY);
        if (overrides != null) {
            try {
                this.overrides = JSON.parse(overrides);
            }
            catch (e) {
                StatsigLocalStorage_1.default.removeItem(OVERRIDES_STORE_KEY);
            }
        }
    };
    StatsigStore.prototype.save = function (userCacheKey, jsonConfigs) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var minTime, minKey, _i, _c, entry;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.values[userCacheKey] = __assign(__assign({}, jsonConfigs), { sticky_experiments: (_b = (_a = this.values[userCacheKey]) === null || _a === void 0 ? void 0 : _a.sticky_experiments) !== null && _b !== void 0 ? _b : {}, time: Date.now() });
                        if (Object.entries(this.values).length > MAX_USER_VALUE_CACHED) {
                            minTime = null;
                            minKey = null;
                            for (_i = 0, _c = Object.entries(this.values); _i < _c.length; _i++) {
                                entry = _c[_i];
                                if (entry[1] == null) {
                                    continue;
                                }
                                if (minTime == null || minTime > entry[1].time) {
                                    minTime = entry[1].time;
                                    minKey = entry[0];
                                }
                            }
                            if (minKey) {
                                delete this.values[minKey];
                            }
                        }
                        if (!StatsigAsyncStorage_1.default.asyncStorage) return [3 /*break*/, 2];
                        return [4 /*yield*/, StatsigAsyncStorage_1.default.setItemAsync(INTERNAL_STORE_KEY, JSON.stringify(this.values))];
                    case 1:
                        _d.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        StatsigLocalStorage_1.default.setItem(INTERNAL_STORE_KEY, JSON.stringify(this.values));
                        _d.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function (gateName, ignoreOverrides) {
        var _a, _b;
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        var gateNameHash = getHashValue(gateName);
        var gateValue = { value: false, rule_id: '', secondary_exposures: [] };
        if (!ignoreOverrides && this.overrides.gates[gateName] != null) {
            gateValue = {
                value: this.overrides.gates[gateName],
                rule_id: 'override',
                secondary_exposures: [],
            };
        }
        else {
            gateValue =
                (_b = (_a = this.values[this.getCurrentUserCacheKey()]) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash]) !== null && _b !== void 0 ? _b : gateValue;
        }
        this.sdkInternal
            .getLogger()
            .logGateExposure(this.sdkInternal.getCurrentUser(), gateName, gateValue.value, gateValue.rule_id, gateValue.secondary_exposures);
        return gateValue.value === true;
    };
    StatsigStore.prototype.getConfig = function (configName, ignoreOverrides) {
        var _a, _b;
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        var configNameHash = getHashValue(configName);
        var configValue = new DynamicConfig_1.default(configName);
        if (!ignoreOverrides && this.overrides.configs[configName] != null) {
            configValue = new DynamicConfig_1.default(configName, this.overrides.configs[configName], 'override');
        }
        else if (((_a = this.values[this.getCurrentUserCacheKey()]) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this.values[this.getCurrentUserCacheKey()]) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            configValue = this.createDynamicConfig(configName, rawConfigValue);
        }
        this.sdkInternal
            .getLogger()
            .logConfigExposure(this.sdkInternal.getCurrentUser(), configName, configValue.getRuleID(), configValue._getSecondaryExposures());
        return configValue;
    };
    StatsigStore.prototype.getExperiment = function (expName, keepDeviceValue, ignoreOverrides) {
        var _a;
        if (keepDeviceValue === void 0) { keepDeviceValue = false; }
        if (ignoreOverrides === void 0) { ignoreOverrides = false; }
        var expNameHash = getHashValue(expName);
        var exp = new DynamicConfig_1.default(expName);
        if (!ignoreOverrides && this.overrides.configs[expName] != null) {
            exp = new DynamicConfig_1.default(expName, this.overrides.configs[expName], 'override');
        }
        else {
            var userCacheKey = this.getCurrentUserCacheKey();
            var userValues = this.values[userCacheKey];
            var stickyValue = (_a = userValues === null || userValues === void 0 ? void 0 : userValues.sticky_experiments[expNameHash]) !== null && _a !== void 0 ? _a : this.stickyDeviceExperiments[expNameHash];
            var latestValue = userValues === null || userValues === void 0 ? void 0 : userValues.dynamic_configs[expNameHash];
            // If flag is false, or experiment is NOT active, simply remove the
            // sticky experiment value, and return the latest value
            if (!keepDeviceValue || (latestValue === null || latestValue === void 0 ? void 0 : latestValue.is_experiment_active) == false) {
                this.removeStickyValue(userCacheKey, expName);
                exp = this.createDynamicConfig(expName, latestValue);
            }
            else if (stickyValue != null) {
                // If sticky value is already in cache, use it
                exp = this.createDynamicConfig(expName, stickyValue);
            }
            else if (latestValue != null) {
                // Here the user has NOT been exposed before.
                // If they are IN this ACTIVE experiment, then we save the value as sticky
                if (latestValue.is_experiment_active &&
                    latestValue.is_user_in_experiment) {
                    if (latestValue.is_device_based) {
                        // save sticky values in memory
                        this.stickyDeviceExperiments[expNameHash] = latestValue;
                    }
                    else if (userValues) {
                        userValues.sticky_experiments[expNameHash] = latestValue;
                    }
                    // also save to persistent storage
                    this.saveStickyValuesToStorage();
                }
                exp = this.createDynamicConfig(expName, latestValue);
            }
        }
        this.sdkInternal
            .getLogger()
            .logConfigExposure(this.sdkInternal.getCurrentUser(), expName, exp.getRuleID(), exp._getSecondaryExposures());
        return exp;
    };
    StatsigStore.prototype.overrideConfig = function (configName, value) {
        try {
            JSON.stringify(value);
        }
        catch (e) {
            console.warn('Failed to stringify given config override.  Dropping', e);
            return;
        }
        this.overrides.configs[configName] = value;
        this.saveOverrides();
    };
    StatsigStore.prototype.overrideGate = function (gateName, value) {
        this.overrides.gates[gateName] = value;
        this.saveOverrides();
    };
    StatsigStore.prototype.removeGateOverride = function (gateName) {
        if (gateName == null) {
            this.overrides.gates = {};
        }
        else {
            delete this.overrides.gates[gateName];
        }
        this.saveOverrides();
    };
    StatsigStore.prototype.removeConfigOverride = function (configName) {
        if (configName == null) {
            this.overrides.configs = {};
        }
        else {
            delete this.overrides.configs[configName];
        }
        this.saveOverrides();
    };
    StatsigStore.prototype.getAllOverrides = function () {
        return this.overrides;
    };
    StatsigStore.prototype.saveOverrides = function () {
        try {
            StatsigLocalStorage_1.default.setItem(OVERRIDES_STORE_KEY, JSON.stringify(this.overrides));
        }
        catch (e) {
            console.warn('Failed to persist gate/config overrides');
        }
    };
    StatsigStore.prototype.getCurrentUserCacheKey = function () {
        return this.sdkInternal.getCurrentUserCacheKey();
    };
    StatsigStore.prototype.createDynamicConfig = function (name, apiConfig) {
        return new DynamicConfig_1.default(name, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id, apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures);
    };
    StatsigStore.prototype.removeStickyValue = function (userCacheKey, key) {
        var _a;
        (_a = this.values[userCacheKey]) === null || _a === void 0 ? true : delete _a.sticky_experiments[key];
        delete this.stickyDeviceExperiments[key];
        this.saveStickyValuesToStorage();
    };
    StatsigStore.prototype.saveStickyValuesToStorage = function () {
        if (StatsigAsyncStorage_1.default.asyncStorage) {
            StatsigAsyncStorage_1.default.setItemAsync(INTERNAL_STORE_KEY, JSON.stringify(this.values));
            StatsigAsyncStorage_1.default.setItemAsync(STICKY_DEVICE_EXPERIMENTS_KEY, JSON.stringify(this.stickyDeviceExperiments));
        }
        else {
            StatsigLocalStorage_1.default.setItem(INTERNAL_STORE_KEY, JSON.stringify(this.values));
            StatsigLocalStorage_1.default.setItem(STICKY_DEVICE_EXPERIMENTS_KEY, JSON.stringify(this.stickyDeviceExperiments));
        }
    };
    return StatsigStore;
}());
exports.default = StatsigStore;
